import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import React, { Component } from "react";
import {
  collection,
  deleteDoc,
  doc,
  getFirestore,
  onSnapshot,
  query,
  setDoc,
} from "firebase/firestore";

export default class CRUDfirebase extends Component {
  state = {
    gestion: new Date().getFullYear(),
    titulo: "",
    tipo: "",
    codigo: "",
    link: "",
    resumenes: [],
    subtmitButton: "Registrar resúmen",
    idToDelete: "",
  };
  render() {
    const db = getFirestore(this.props.auth);
    function createDoc(path, data) {
      const docPath = doc(db, path);
      setDoc(docPath, data);
    }
    const q = query(collection(db, "resumenes"));
    onSnapshot(q, (querySnapshot) => {
      const resumenes = [];
      let lastUID = 0;
      querySnapshot.forEach((doc) => {
        if (parseInt(doc.id) > lastUID) lastUID = parseInt(doc.id);
        resumenes.push({ ...doc.data(), uid: doc.id });
      });
      this.setState({
        lastUID: lastUID + 1,
        resumenes: resumenes,
      });
    });
    const años = Array.from(
      new Set(this.state.resumenes.map((e) => e.gestion))
    ).sort();
    return (
      <div className="register-abstract-model">
        <div className="CRUD-abstract">
          <Stack spacing={1} alignItems="center">
            <Typography sx={{ my: 2 }} variant="h6">
              Subir nuevo resúmen
            </Typography>
            <TextField
              type="number"
              value={this.state.gestion}
              onChange={(e) => {
                this.setState({
                  gestion: e.target.value,
                });
              }}
              label="Gestión"
              size="small"
              variant="outlined"
            />
            <TextField
              multiline
              value={this.state.titulo}
              onChange={(e) => {
                this.setState({
                  titulo: e.target.value,
                });
              }}
              label="Título"
              size="small"
              variant="outlined"
            />
            <TextField
              value={this.state.tipo}
              onChange={(e) => {
                this.setState({
                  tipo: e.target.value,
                });
              }}
              label="Tipo"
              size="small"
              variant="outlined"
            />
            <TextField
              multiline
              value={this.state.codigo}
              onChange={(e) => {
                this.setState({
                  codigo: e.target.value,
                });
              }}
              label="Código"
              size="small"
              variant="outlined"
            />
            <TextField
              multiline
              value={this.state.link}
              onChange={(e) => {
                this.setState({
                  link: e.target.value,
                });
              }}
              label="Link de descarga"
              size="small"
              variant="outlined"
            />
            <Button
              sx={{ width: "fit-content" }}
              disabled={
                this.state.codigo === "" ||
                this.state.gestion === "" ||
                this.state.link === "" ||
                this.state.tipo === "" ||
                this.state.titulo === ""
              }
              size="small"
              variant="contained"
              onClick={() => {
                createDoc("resumenes/" + this.state.lastUID, {
                  codigo: this.state.codigo,
                  gestion: this.state.gestion,
                  link: this.state.link,
                  tipo: this.state.tipo,
                  titulo: this.state.titulo,
                });
                this.setState({
                  codigo: "",
                  gestion: new Date().getFullYear(),
                  link: "",
                  tipo: "",
                  titulo: "",
                  subtmitButton: "Registrar resúmen",
                });
              }}
            >
              Subir
            </Button>
            <Typography sx={{ my: 2 }} variant="h6">
              Eliminar un resumen
            </Typography>
            <TextField
              type="number"
              value={this.state.idToDelete}
              onChange={(e) => {
                this.setState({
                  idToDelete: e.target.value,
                });
              }}
              label="ID a eliminar"
              size="small"
              variant="outlined"
            />
            <Button
              sx={{ width: "fit-content" }}
              disabled={this.state.idToDelete === ""}
              size="small"
              variant="contained"
              onClick={async () => {
                await deleteDoc(doc(db, "resumenes", this.state.idToDelete));
              }}
            >
              Eliminar
            </Button>
          </Stack>
        </div>
        <div className="CRUD-list">
          <Stack spacing={2}>
            {años.map((año) => (
              <Accordion id={año}>
                <AccordionSummary>
                  Resúmenes de la gestion {año}
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer sx={{ mx: "auto" }} component={Paper}>
                    <Table>
                      <TableHead>
                        <TableCell>ID</TableCell>
                        <TableCell>Código</TableCell>
                        <TableCell>Gestión</TableCell>
                        <TableCell>Tipo</TableCell>
                        <TableCell>Título</TableCell>
                        <TableCell>Link</TableCell>
                      </TableHead>
                      <TableBody>
                        {this.state.resumenes
                          .filter((res) => res.gestion === año)
                          .map((res) => (
                            <TableRow>
                              <TableCell>{res.uid}</TableCell>
                              <TableCell>{res.codigo}</TableCell>
                              <TableCell>{res.gestion}</TableCell>
                              <TableCell>{res.tipo}</TableCell>
                              <TableCell>{res.titulo}</TableCell>
                              <TableCell>{res.link}</TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            ))}
            {/* <Button variant="outlined" onClick={() => {
                const abstracts = require("./resources/Abstracts.json");
                abstracts.forEach((a, i) => {
                  createDoc("resumenes/" + i, {
                    codigo: a.descripcion,
                    gestion: a.gestion,
                    link: a.url,
                    tipo: a.tipo,
                    titulo: a.nombre,
                  });
                });
                console.log(abstracts);
            }}>Actualizar Abstracts</Button> */}
          </Stack>
        </div>
      </div>
    );
  }
}
